import { ListViewColumnLabels } from '@modules/common/models/enums'
import { IAttribute } from '@modules/wholesale/buyingSessionCollection/stores/AttributeSortStore'

export const SortAttributesList: Array<IAttribute> = [
  {
    name: 'Order Qty',
    attributeName: ListViewColumnLabels.OrderQty,
    value: 'orderQuantity',
    isSelected: false,
    disabled: false
  },
  {
    name: 'Order Value',
    attributeName: ListViewColumnLabels.OrderValue,
    value: 'orderValue',
    isSelected: false,
    disabled: false
  }
]
